import { render, staticRenderFns } from "./CardLeadStatus.vue?vue&type=template&id=5d9c66c3&scoped=true"
import script from "./CardLeadStatus.vue?vue&type=script&lang=js"
export * from "./CardLeadStatus.vue?vue&type=script&lang=js"
import style0 from "./CardLeadStatus.vue?vue&type=style&index=0&id=5d9c66c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9c66c3",
  null
  
)

export default component.exports